const options  = {
  messages: {
    userExists: 'Пользователь с такими данными уже зарегистрирован. <a href="javascript:;" onclick="MicroModal.show(\'modal-login\')">Авторизоваться</a>',
    deliveryNotPossible: 'Нет доставки в этот населенный пункт.',
    missingValue: {
      default: 'Поле не должно быть пустым',
      radio: 'Нужно выбрать значение'
    },
    patternMismatch: {
      email: 'Введите корректный email адрес',
      tel: 'Введите корректный телефон'
    },
    passConfirm: 'Пароли не совпадают',
    wrongLength: {
      under: 'Поле должно содержать не менее {minLength} символов.'
    }
  },
  customValidations: {
    userExists: field => {
      const selector = field.getAttribute('data-bouncer-exclude');
      if (!selector) return false;
      return selector.includes(field.value);
    },
    deliveryNotPossible: field => {
      const selector = field.getAttribute('data-bouncer-delivery-not-possible');
      if (!selector) return false;
      return selector.includes(field.value);
    },
    passConfirm: field => {

      // Look for a selector for a field to compare
      // If there isn't one, return false (no error)
      const selector = field.getAttribute('data-bouncer-match');
      if (!selector) return false;

      // Get the field to compare
      const otherField = field.form.querySelector(selector);
      if (!otherField) return false;

      // Compare the two field values
      // We use a negative comparison here because if they do match, the field validates
      // We want to return true for failures, which can be confusing
      return otherField.value !== field.value;

    }
  }
};

export const validateConfig = {
  errorClass: 'help-text error-message',
  messages: Object.assign(options.messages, {}),
  disableSubmit: true,
  emitEvents: true,
  customValidations: Object.assign(options.customValidations, {}),
};
